import { handleUnauthorizedSession, SessionExpiredError } from '../../../api';
import { RAG_API_URL } from '../../../config/env';
import { fetchWithAnswersAuth } from '../../../api/auth';

const isAuthFailureDetail = (detail) => (
  typeof detail === 'string'
  && /Authorization header required|Invalid or expired token/i.test(detail)
);

/** Central registry of Answers RAG HTTP endpoints. */
export const AnswersEndpoints = {
  QUERY: `${RAG_API_URL}/query`,
  FILTER_OPTIONS: `${RAG_API_URL}/query/filter-options`,
  FILTER_MATCH_COUNT: `${RAG_API_URL}/query/filter-match-count`,
  RESOLVE_CITATION: `${RAG_API_URL}/query/resolve-citation`,
};

/**
 * Authenticated fetch for Answers RAG APIs.
 * @param {string} url
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */
export async function answersFetch(url, init = {}) {
  return fetchWithAnswersAuth(url, init);
}

/**
 * JSON request with standard Answers error handling.
 * @param {string} url
 * @param {RequestInit} [init]
 */
export async function answersFetchJson(url, init = {}) {
  const response = await answersFetch(url, init);
  if (!response.ok) {
    const err = await response.json().catch(() => ({ detail: response.statusText }));
    const detail = err.detail || response.statusText || `Request failed: ${response.status}`;
    if (response.status === 401 || isAuthFailureDetail(detail)) {
      handleUnauthorizedSession();
      throw new SessionExpiredError();
    }
    throw new Error(detail);
  }
  return response.json();
}
